var _defs, _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg00056IconServiceCdnProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b300f0d1-2ad8-4418-a1c5-23d0b9d21841",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8cad6fd-ec7f-45e9-be2a-125e8b87bd03",
    x1: 10.79,
    y1: 2.17,
    x2: 10.79,
    y2: 16.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-web-43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.7,
    y: 5.49,
    width: 1.18,
    height: 5.26,
    rx: 0.52,
    transform: "translate(-3.83 12.41) rotate(-90)",
    fill: "#b3b3b3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.04,
    y: 7.88,
    width: 1.18,
    height: 5.26,
    rx: 0.52,
    transform: "translate(-7.88 13.14) rotate(-90)",
    fill: "#a3a3a3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.7,
    y: 10.26,
    width: 1.18,
    height: 5.26,
    rx: 0.52,
    transform: "translate(-8.6 17.19) rotate(-90)",
    fill: "#7a7a7a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,11a3.28,3.28,0,0,0-2.81-3.18,4.13,4.13,0,0,0-4.21-4,4.23,4.23,0,0,0-4,2.8,3.89,3.89,0,0,0-3.38,3.8,4,4,0,0,0,4.06,3.86l.36,0h6.58l.17,0A3.32,3.32,0,0,0,18,11Z",
    fill: "url(#b8cad6fd-ec7f-45e9-be2a-125e8b87bd03)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg00056IconServiceCdnProfiles);
export default __webpack_public_path__ + "static/media/00056-icon-service-CDN-Profiles.bae8f72d2a115e6d82bbd705754bdf49.svg";
export { ForwardRef as ReactComponent };